<template>
<div id="documents">

<!-- Breadcrumbs -->
    <section class="city-breadcrumb"></section>
        <div class="row breadcrumb-box">
            <div class="mr-3 ml-5">
                <p class="mbr-text city-footer-font-bread display-7 ">
                    <a class="city-footer-link-sub" href="/">Home</a> > {{ title }}</p>
            </div>
        </div> 

<!-- Content -->
        <div class="container">
            <div class="row">
                <div class="card container-fluid ml-3">
                    <img class="card-img-top mt-3" id="card-img-base64">
                    <div class="card-body mb-5">
                        <h1 class="city-title mt-2 ">{{ title }}</h1>
                        <div class="large-city-green-div "></div>
                        <div class="">

                    <div class="city-p">
                    
                    <div class="container">
                        <div class="col-12 mb-3">
                            <img src="../index_files/images/document-icon.svg" alt="" class="mr-4" style="float: left;">
                            <a href="https://www-cdn.cctexas.com/sites/default/files/CC-Consent-Decree.pdf">
                                <p>City of Corpus Christi Consent Decree&nbsp;»<br>
                                <span><small>January 11, 2021</small></span>
                                </p>
                            </a>
                            <br>
                        </div>

                        <div class="col-12 mb-3">
                            <img src="../index_files/images/document-icon.svg" alt="" class="mr-4" style="float: left;">
                            <a href="https://www.cctexas.com/sites/default/files/cleanbays-CMOM-Rev%206-EPA.pdf">
                                <p>Capacity, Management, Operations and Maintenance Plan&nbsp;»<br>
                                <small>August 20, 2020</small>
                                </p>
                            </a>
                            <br>
                        </div>

                        <div class="col-12 mb-3">
                            <img src="../index_files/images/document-icon.svg" alt="" class="mr-4" style="float: left;">
                            <a href="https://www.cctexas.com/sites/default/files/cleanbays-SSORP-LSRP-EPA.pdf">
                                <p>Sanitary Sewer Overflow Response Plan&nbsp;»<br>
                                <small>August 20, 2020</small>
                                </p>
                            </a>
                            <br>
                        </div>

                        <div class="col-12 mb-3">
                            <img src="../index_files/images/document-icon.svg" alt="" class="mr-4" style="float: left;">
                            <a href="https://www.cctexas.com/sites/default/files/LSRP-EPA-Approved-2020-08-20.pdf">
                                <p>Lift Station Response Plan&nbsp;»<br>
                                <small>August 20, 2020</small>
                                </p>
                            </a>
                            <br>
                        </div>

                        <div class="col-12 mb-3">
                            <img src="../index_files/images/document-icon.svg" alt="" class="mr-4" style="float: left;">
                            <a href="https://www.cctexas.com/sites/default/files/cleanbays-FOG-Manual-EPA.pdf">
                                <p>Fats, Oil &amp; Grease (FOG) Program Manual and Policies&nbsp;»<br>
                                <small>June 4, 2019</small>
                                </p>
                            </a>
                            <br>
                        </div>

                    </div>
                    </div>
                    </div>
                </div> <!-- Content Here -->
            </div>
        </div>
    </div>
</div>

</template>

<script>
export default {
  name: 'documents',
  data () {
    return {
        title: 'Document Library',
        crumbLink:'',
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/Documents.vue